// extracted by mini-css-extract-plugin
module.exports = {"modal":"Modal_modal__3je8J","showModal":"Modal_showModal__TugqO","outer":"Modal_outer__1r554","close":"Modal_close__xvmmY","gallery":"Modal_gallery__2D8VO"};